require('@webhare-system/frameworks/mootools/core');
var $todd = require("./support");
var compatdragdrop = require('@webhare-system/compat/dragdrop');
var urlapi = require('@webhare-system/internal/url');


/** Try to start a drag action
    @param items
    @cell items.id
    @cell items.info
    @cell items.info.type
    @cell items.info.candownload
    @cell items.info.data
    @cell items.info.data.filename
    @cell items.info.data.mimetype
    @cell items.info.data.flags
*/
$todd.tryStartDrag = function(comp, items, event)
{
//  console.log('tryStartDrag');
  if (!items.length)
    return false;

  var infos = [];
  for (var i = 0; i < items.length; ++i)
    if (!items[i].info)
      return false;
    else
      infos.push({ type: items[i].info.type, data: items[i].info.data, id: items[i].id });

  var download = null;
  if (items.length == 1 && items[0].info.candownload)
  {
    //ADDME: rowkey?
    var url = urlapi.resolveToAbsoluteURL(
        window.location.href,
        comp.getFileTransferURL('download', { type: 'dragout', rowkey: items[0].id }, { filename: items[0].info.data.filename }).url);
    download =
        { filename:     items[0].info.data.filename
        , mimetype:     items[0].info.data.mimetype
        , url:          url
        };
  }

  var dragInfo = new compatdragdrop.DragStartData('all');
  dragInfo.localdata = { source: comp, items: infos };
  dragInfo.file = download;

//  console.log('Storing draginfo: ', dragInfo);

  dragInfo.storeIntoEvent(event);
  return true;
};




// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/dragdrop.es